<template>
  <v-container fluid>
    <v-row>
      <v-col xs="12">
        <v-card v-if="!!instancesOpen.length" flat>
          <v-card-title>
            Recent checklists
            <span class="ml-3">
              <sl-btn-instance-create icon outlined large color="instance" :master="master" />
            </span>
          </v-card-title>
          <v-row align="start" justify="start">
            <v-col
              v-for="instance in instancesOpen.slice(0, 3)"
              :key="instance.id"
              xs="12"
              sm="6"
              md="4"
            >
              <instance-card :instance="instance" :showMasterTitle="false" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs="12">
        <v-card>
          <v-card-title>
            Open checklists
            <span class="ml-3">
              <sl-btn-instance-create icon outlined large color="instance" :master="master" />
            </span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="instancesOpenTableSearch"
              append-icon="mdi-magnify"
              label="Search in checklist titles"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="instancesOpenTableHeaders"
            :items="instancesOpen"
            :items-per-page="10"
            :search="instancesOpenTableSearch"
            :loading="loadingData"
            loading-text="Loading... Please wait"
            @click:row="openInstance"
          >
            <template v-slot:item.title="{ item }">
              <span class="font-weight-medium instance--text">
                <sl-text-truncated :text="item.title" :lengthMax="titleCharsShownMax" />
              </span>
            </template>
            <template v-slot:item.createdBy="{ item }">
              <sl-text-truncated :text="item.creator.firstName" :lengthMax="nameCharsShownMax" />
              <sl-text-truncated :text="item.creator.lastName" :lengthMax="nameCharsShownMax" />
            </template>
            <template v-slot:item.createdAt="{ item }">
              <sl-time :time="item.createdAt" dateOnly />
            </template>
            <template v-slot:item.updatedBy="{ item }">
              <sl-text-truncated
                :text="item.lastEntryUpdate.user.firstName"
                :lengthMax="nameCharsShownMax"
              />
              <sl-text-truncated
                :text="item.lastEntryUpdate.user.lastName"
                :lengthMax="nameCharsShownMax"
              />
            </template>
            <template v-slot:item.updatedAt="{ item }">
              <sl-time :time="item.lastEntryUpdate.time" />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="instance"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openInstanceInNewTab(item)"
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>Open checklist in a new tab</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
        <!-- <v-btn outlined @click="instancesArchivedShow = !instancesArchivedShow">
          <v-icon left>{{ !!instancesArchivedShow ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
          {{ !!instancesArchivedShow ? 'Hide archived' : 'Show archived' }}
        </v-btn> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Archived checklists
            <v-spacer></v-spacer>
            <v-text-field
              v-model="instancesArchivedTableSearch"
              append-icon="mdi-magnify"
              label="Search in checklist titles"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="instancesArchivedTableHeaders"
            :items="instancesArchived"
            :items-per-page="10"
            :search="instancesArchivedTableSearch"
            :loading="loadingData"
            loading-text="Loading... Please wait"
            @click:row="openInstance"
          >
            <template v-slot:item.title="{ item }">
              <span class="font-weight-medium">
                <sl-text-truncated :text="item.title" :lengthMax="titleCharsShownMax" />
              </span>
            </template>
            <template v-slot:item.createdBy="{ item }">
              <sl-text-truncated :text="item.creator.firstName" :lengthMax="nameCharsShownMax" />
              <sl-text-truncated :text="item.creator.lastName" :lengthMax="nameCharsShownMax" />
            </template>
            <template v-slot:item.createdAt="{ item }">
              <sl-time :time="item.createdAt" dateOnly />
            </template>
            <template v-slot:item.archivedBy="{ item }">
              <sl-text-truncated :text="item.archivedBy.firstName" :lengthMax="nameCharsShownMax" />
              <sl-text-truncated :text="item.archivedBy.lastName" :lengthMax="nameCharsShownMax" />
            </template>
            <template v-slot:item.archivedAt="{ item }">
              <sl-time :time="item.archivedAt" dateOnly />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="instance"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openInstanceInNewTab(item)"
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>Open checklist in a new tab</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import ClInstance from '@/models/ClInstance'

import InstanceCard from '@/components/InstanceCard'
import SlBtnInstanceCreate from '@/components/SlBtnInstanceCreate'
import SlTime from '@/components/SlTime'
import SlTextTruncated from '@/components/SlTextTruncated'

export default {
  components: {
    InstanceCard,
    SlBtnInstanceCreate,
    SlTime,
    SlTextTruncated,
  },

  props: {
    master: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loadingData: true,
      instancesArchived: [],
      // instancesArchivedShow: false,
      instancesArchivedTableHeaders: [
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        { text: 'Created by', value: 'createdBy' },
        { text: 'Created on', value: 'createdAt' },
        { text: 'Archived by', value: 'archivedBy' },
        { text: 'Archived on', value: 'archivedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      instancesArchivedTableSearch: '',
      instancesOpen: [],
      instancesOpenTableHeaders: [
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        { text: 'Created by', value: 'createdBy' },
        { text: 'Created on', value: 'createdAt' },
        { text: 'Last change by', value: 'updatedBy' },
        { text: 'Last change at', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      instancesOpenTableSearch: '',
      nameCharsShownMax: 16,
      titleCharsShownMax: 32,
    }
  },

  computed: {
    //
    ...mapState(['userLogged']),
  },

  created() {
    this.queries = [
      ClInstance.select({
        get: `{
          id,
          title,
          creator {
            id, firstName, lastName
          },
          createdAt,
          archived,
          archivedBy {
           id, firstName, lastName
          },
          archivedAt,
          currentlyOnUsers {
            id, firstName, lastName
          },
          lastEntryUpdate {
            user {
              id, firstName, lastName
            },
            time
          },
          clInstanceEntries {
            id,
            checked
          }
        }`,
        by: { clMasterId: this.master.id },
        onChange: data => {
          this.instancesArchived = data
            .filter(instance => instance.archived === true)
            .sort(function(a, b) {
              return new Date(b.archivedAt) - new Date(a.archivedAt)
            })
          this.instancesOpen = data
            .filter(instance => instance.archived === false)
            .sort(function(a, b) {
              return new Date(b.lastEntryUpdate.time) - new Date(a.lastEntryUpdate.time)
            })
          this.loadingData = false
        },
        onError: error => {
          Logger.error('ERROR in loading data:', error)
          this.toastSet({
            message: 'Error in loading data',
            color: 'error',
          })
        },
      }),
    ]
  },

  mounted() {
    //
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    openInstance(instance) {
      Logger.debug(instance.id)
      this.$router.push({ path: '/checklist/' + instance.id })
    },
    openInstanceInNewTab(instance) {
      const route = this.$router.resolve({ path: '/checklist/' + instance.id })
      window.open(route.href, '_blank')
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
